import * as React from 'react';
import { Provider } from 'react-redux';
import store, { dispatch } from '../../../../store/configureStore';
import { RateKanbanPollHOC } from '../../polls/rateKanbanPoll/hocs/RateKanbanPoll/RateKanbanPollHOC';
import { createRoot, Root } from 'react-dom/client';
import { authUserSetRateKanbanPoll } from '../../../../rest/effects/authUser/authUserSetRateKanbanPoll';
import { DEFAULT_POLL } from '../../../../const';

export class RateKanbanPoll {
    el: HTMLElement;
    root: Root;

    constructor () {
        this.el = document.createElement('div');
        this.el.className = 'poll-placeholder poll-placeholder--rate-kanban';
        document.body.append(this.el);
        this.root = createRoot(this.el);
        this.render();
    }

    render () {
        this.root.render(
            <Provider store={store}>
                <RateKanbanPollHOC />
            </Provider>
        );
    }

    remove () {
        this.root.unmount();
        if (!this.el) return;
        this.el.remove();
        this.el = null;
    }
}

//@ts-ignore для тестов
window.resetRateKanbanPoll = function() {
    dispatch(authUserSetRateKanbanPoll({
        ...DEFAULT_POLL,
        isShowed: null,
        isTriggered: null,
    }));
}
